import styled from 'styled-components'

export const BMWCustomStyle = styled.div``
